import { formatLocalDate } from "src/utils/common";

class ClientVoucherModel {
    constructor(data) {
        this.Id = data?.Id ?? null;
        this.VoucherNumber = data?.VoucherNumber ?? null;
        this.ReservationNumber = data?.ReservationNumber ?? null;
        this.Active = data?.Active ?? false;
        this.Timestamp = data?.Timestamp ? formatLocalDate(data.Timestamp) : null;

        this.Services = Array.isArray(data?.Details?.Services)
            ? data.Details.Services.map(service => ({
                Name: service?.Name ?? null,
                Address: service?.Address ?? null,
                ConfirmationNumber: service?.ConfirmationNumber ?? null,
                CheckIn: service?.CheckIn ? formatLocalDate(service.CheckIn) : null,
                CheckOut: service?.CheckOut ? formatLocalDate(service.CheckOut) : null,
                Items: (service?.Items ?? []).map(item => ({
                    UnitName: item?.UnitName ?? null,
                    UnitType: item?.UnitType ?? null,
                    NumberOfNights: Number(item?.NumberOfNights) || 0,
                    NumberOfUnits: Number(item?.NumberOfUnits) || 0,
                    PaxCount: Number(item?.PaxCount) || 0,
                    Supplements: item?.Supplements ?? [],
                    Discounts: item?.Discounts ?? []
                }))
            }))
            : [];
        this.Hotels = Array.isArray(data?.Details?.Hotels)
            ? data.Details.Hotels.map(hotel => ({
                Name: hotel?.Name ?? null,
                Address: hotel?.Address ?? null,
                ConfirmationNumber: hotel?.ConfirmationNumber ?? null,
                CheckIn: hotel?.CheckIn ? formatLocalDate(hotel.CheckIn) : null,
                CheckOut: hotel?.CheckOut ? formatLocalDate(hotel.CheckOut) : null,
                Rooms: (hotel?.Rooms ?? []).map(room => ({
                    RoomName: room?.RoomName ?? null,
                    RoomType: room?.RoomType ?? null,
                    NumberOfNights: Number(room?.NumberOfNights) || 0,
                    NumberOfRooms: Number(room?.NumberOfRooms) || 0,
                    PaxCount: Number(room?.PaxCount) || 0,
                    Supplements: room?.Supplements ?? [],
                    Discounts: room?.Discounts ?? []
                }))
            }))
            : [];

        const hotelPaxCount = this.Hotels.reduce((sum, hotel) => (
            sum + hotel.Rooms.reduce((roomSum, room) => roomSum + room.PaxCount, 0)
        ), 0);

        const servicePaxCount = this.Services.reduce((sum, service) => (
            sum + service.Items.reduce((itemSum, item) => itemSum + item.PaxCount, 0)
        ), 0);

        this.PaxCount = hotelPaxCount + servicePaxCount;

        this.Guests = Array.isArray(data?.Details?.Guests)
            ? data.Details.Guests.map(guest => ({
                Name: guest?.Name ?? null,
                Age: Number(guest?.Age) || 0
            }))
            : [];
    }
}

export default ClientVoucherModel;